export const addTrailingSlash = (string, noSlash = false) => {
  const symbol = noSlash ? '' : '/$1';

  return string.replace(/\/?(\?|#|$)/, symbol);
};
